import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CdnService } from '../../../../_services/_cdn/cdn.service';
import { ShgProfileService } from '../../../../_services/_profile/shg-profile.service';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../../../_services/_common/common.service';
import { ImageTypeEnum } from '../../../../_enum/common.enum';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
    selector: 'lokos-member-id-card',
    templateUrl: './member-id-card.component.html',
    styleUrls: ['./member-id-card.component.scss'],
    standalone: false,
})
export class MemberIDCardComponent implements OnInit, OnDestroy {
    memberPhoto: string | null = null;
    qrCodeUrl: string | null = null;
    headerLeader = '';
    breadcrumbs: any[] = [
        { label: 'shgProfile', link: '/main/profile/shg-profile' },
        { label: 'memberProfile', link: '/main/profile/shg-member-list' },
        {
            label: 'memberIDCard',
            link: '',
        },
    ];

    contCode!: string;
    shgName!: string;
    shgCode!: any;
    relationName!: string;
    memDob!: string;
    regDate!: string;
    memPost!: number;
    contName!: string;
    cboId!: string;
    uuid!: string;
    memberImage!: string;
    panchayatId!: any;
    villageId!: any;
    stateId!: any;
    districtId!: any;
    blockId!: any;
    imageflag!: any;
    memRow!: any;
    imgNameUrl: any;
    guid!: any;
    memberDocument!: any;
    imageUrl: any = environment.reportsApiBaseUrl;
    imgBaseUrlV2: any;
    shgId!: any;
    memberUUId!: any;
    joiningDate!: any;

    //  Display
    memDesignation = '';
    shgFormationDate = '';
    dataToString = '';
    memPhoto = '';
    shgFormDate = '';
    lookupDataList: any[] = [];
    imageError = true;
    imageData: any;
    private blobUrl: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private cdnService: CdnService,
        private shgProfileService: ShgProfileService,
        private commonService: CommonService
    ) { }

    ngOnInit(): void {
        this.route.queryParams.subscribe((params) => {
            console.log('Query Params:', params);
            this.shgId = params['contId'] ?? '';
            this.memberUUId = params['memberUUId'] ?? '';
            this.contCode = params['cont_code'] ?? '';
            this.contName = params['cont_name'] ?? '';
            this.shgName = params['shg_name'] ?? '';
            this.relationName = params['relation_name'] ?? '';
            this.memDob = params['mem_dob'];
            this.regDate = params['reg_date'] ?? '';
            this.memPost = Number(params['designation']);
            this.uuid = params['uuid'] ?? '';
            this.stateId = params['stateId'] ?? '';
            this.districtId = params['districtId'] ?? '';
            this.blockId = params['blockId'] ?? '';
            this.panchayatId = params['panchayatId'] ?? '';
            this.villageId = params['villageId'] ?? '';
            this.guid = params['contGuid'] ?? '';
            this.memberImage = params['member_image'] ?? '';
            this.memberDocument = params['member_document'] ?? '';
            this.shgCode = params['shgCode'] ?? '';
            this.shgFormationDate = params['shgFormationDate'] ?? '';
            this.memDesignation = params['designationName'] ?? '';
        });
        // this.getLookupData();
        this.loadMemberBasic();
    }

    /** Opens an isolated print window scoped to #printAbleArea only */
    printCard(): void {
        const printArea = document.getElementById('printAbleArea');
        if (!printArea) return;

        const content = printArea.innerHTML;
        const qrBase64 = this.getQrBase64();
        const printWindow = window.open('', '_blank', 'width=800,height=650');
        if (!printWindow) return;

        printWindow.document.write(
            this.buildPrintHtml(content, 'SHG ID Card', qrBase64)
        );
        printWindow.document.close();
    }

    /** Generates a PDF of #printAbleArea using the browser's print-to-PDF */
    downloadPdf(): void {
        // const printArea = document.getElementById('printAbleArea');
        // if (!printArea) return;

        // const content = printArea.innerHTML;
        // const qrBase64 = this.getQrBase64();
        // const printWindow = window.open('', '_blank', 'width=800,height=650');
        // if (!printWindow) return;

        // printWindow.document.write(
        //     this.buildPrintHtml(
        //         content,
        //         `SHG_ID_Card_${this.shgName}`,
        //         qrBase64
        //     )
        // );
        // printWindow.document.close();
        const element = document.getElementById('printAbleArea');
        if (!element) return;

        html2canvas(element, { scale: 2 }).then(canvas => {
            const imgData = canvas.toDataURL('image/png');

            const pdf = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a6'
            });

            const imgWidth = 148; // A6 landscape width
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
            pdf.save(`SHG_ID_Card_${this.shgName}.pdf`);
        });
    }
    /** Extracts the rendered QR code canvas/img as a base64 data URL */
    private getQrBase64(): string {
        // angularx-qrcode renders either a <canvas> or an <img> inside .qr-frame
        const qrFrame = document.querySelector('.qr-frame');
        if (!qrFrame) return '';

        // Try canvas first (default output of angularx-qrcode)
        const canvas = qrFrame.querySelector('canvas');
        if (canvas) return canvas.toDataURL('image/png');

        // Fallback: if rendered as <img>
        const img = qrFrame.querySelector('img');
        if (img?.src) return img.src;

        return '';
    }

    /** Shared HTML shell used by both print and PDF export */
    private buildPrintHtml(
        content: string,
        title = 'SHG ID Card',
        qrBase64 = ''
    ): string {
        // Replace the entire <qrcode> component tag with a plain <img> using the captured base64
        // angularx-qrcode leaves a <qrcode> custom element in innerHTML — replace it
        const qrImgTag = qrBase64
            ? `<img src="${qrBase64}" style="width:100%;height:100%;object-fit:contain;" alt="QR Code" />`
            : '<span style="font-size:10px;color:#999;">QR N/A</span>';

        const resolvedContent = content
            // Replace <qrcode ...>...</qrcode> (with any attributes/children)
            .replace(/<qrcode[\s\S]*?<\/qrcode>/gi, qrImgTag)
            // Also handle self-closing variant
            .replace(/<qrcode[^>]*\/>/gi, qrImgTag);

        return `
            <!DOCTYPE html>
            <html lang="en">
            <head>
                <meta charset="UTF-8" />
                <title>${title}</title>
                <style>
                    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
                    body { font-family: 'Segoe UI', 'Trebuchet MS', sans-serif; background: #fff; }
                    .card-actions { display: none !important; }

                    .card-page-wrapper {
                        display: flex; justify-content: center; align-items: center;
                        padding: 20px; background: #fff;
                    }
                    .id-card {
                        position: relative; width: 100%; max-width: 720px;
                        background: #fff; border-radius: 14px;
                        border: 1px solid #dde3ea; overflow: hidden;
                    }
                    .card-header {
                        position: relative; display: flex; flex-direction: row;
                        align-items: center; justify-content: space-between;
                        border-bottom: 2px solid #c8860a; padding: 10px 20px; gap: 12px; overflow: hidden;
                    }
                    .header-bg {
                        position: absolute; inset: 0; width: 100%; height: 100%;
                        object-fit: cover; z-index: 0; pointer-events: none;
                    }
                    .header-logos, .card-title { position: relative; z-index: 1; }
                    .header-logos { display: flex; flex-direction: row; align-items: center; gap: 8px; flex: 0 0 auto; }
                    .header-logo-img { height: 40px; width: auto; object-fit: contain; }
                    .header-logo-img--digital { height: 32px; }
                    .header-divider { width: 1px; height: 32px; background: #dde3ea; }
                    .card-title { font-family: Georgia, serif; font-size: 22px; font-weight: 700; color: #1a3a5c; letter-spacing: 0.5px; margin: 0; text-align: center; flex: 1; }
                    .card-body { display: flex; flex-direction: row; align-items: center; justify-content: center; gap: 28px; padding: 28px 28px 12px; position: relative; z-index: 1; }
                    .card-left { display: flex; flex-direction: column; align-items: center; gap: 12px; flex: 0 0 auto; }
                    .photo-frame { width: 130px; height: 145px; border-radius: 10px; border: 2px solid #dde3ea; background: #dde3ea; overflow: hidden; display: flex; align-items: center; justify-content: center; }
                    .member-photo { width: 100%; height: 100%; object-fit: cover; }
                    .avatar-placeholder { width: 100%; height: 100%; display: flex; align-items: flex-end; justify-content: center; background: #cdd4dc; }
                    .avatar-placeholder svg { width: 90px; height: auto; }
                    .designation-badge { display: flex; flex-direction: column; align-items: center; gap: 4px; }
                    .designation-text { font-size: 13px; font-weight: 700; color: #1a3a5c; letter-spacing: 1.5px; text-transform: uppercase; }
                    .designation-underline { width: 40px; height: 3px; background: #c8860a; border-radius: 2px; }
                    .card-right { display: flex; flex-direction: column; gap: 12px; flex: 1; min-width: 0; }
                    .member-name { font-family: Georgia, serif; font-size: 26px; font-weight: 700; color: #1a1a2e; margin: 0; line-height: 1.2; }
                    .detail-list { display: flex; flex-direction: column; gap: 7px; }
                    .detail-row { display: flex; flex-direction: row; align-items: baseline; }
                    .detail-label { font-size: 12.5px; color: #6b7a8d; font-weight: 500; flex: 0 0 160px; white-space: nowrap; }
                    .detail-sep { font-size: 12.5px; color: #6b7a8d; flex: 0 0 18px; text-align: center; }
                    .detail-value { font-size: 13px; color: #1a1a2e; font-weight: 600; flex: 1; word-break: break-word; }
                    .card-footer { display: flex; flex-direction: row; align-items: flex-end; justify-content: center; padding: 12px 28px 20px; position: relative; z-index: 1; }
                    .footer-left { display: flex; flex-direction: column; gap: 6px; align-items: center; flex: 1; text-align: center; }
                    .footer-line { width: 180px; height: 1px; background: #dde3ea; }
                    .footer-url { font-size: 12.5px; color: #1565c0; font-weight: 500; letter-spacing: 0.2px; }
                    .footer-right { position: absolute; right: 28px; bottom: 20px; }
                    .qr-frame { width: 80px; height: 80px; border: 1px solid #dde3ea; border-radius: 6px; overflow: hidden; display: flex; align-items: center; justify-content: center; background: #fff; padding: 4px; }
                    .card-vector { position: absolute; bottom: 0; left: 0; width: 120px; height: auto; object-fit: contain; z-index: 0; pointer-events: none; }

                    @media print {
                        @page { margin: 0; size: A6 landscape; }
                        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
                    }
                </style>
            </head>
            <body>
                <div class="card-page-wrapper">
                    <div class="id-card">${resolvedContent}</div>
                </div>
                <script>
                    window.onload = function () {
                        window.print();
                        window.onafterprint = function () { window.close(); };
                    };
                <\/script>
            </body>
            </html>
        `;
    }

    loadImage(item: any): void {
        let imageName = '';
        imageName = item['member_image'];

        if (imageName) {
            if (imageName && imageName.includes('/')) {
                imageName = imageName.split('/').pop() || '';
            } else if (imageName) {
                imageName = imageName; // Use the whole string if no slash found
            }
        }
        const imageURL = this.commonService.formatImageUrl(
            imageName,
            {
                uuid: this.memberUUId,
            } as { uuid: string },
            ImageTypeEnum.Profile,
            this.shgId
        );
        this.shgProfileService.getImageFullUrl(imageURL).subscribe({
            next: (response: any) => {
                // Revoke previous blob URL if it exists
                if (this.blobUrl) {
                    URL.revokeObjectURL(this.blobUrl);
                }
                // Convert Blob to Object URL
                if (response instanceof Blob) {
                    this.blobUrl = URL.createObjectURL(response);
                    this.imageData = this.blobUrl;
                    console.log('Image loaded as Blob URL:', this.imageData);
                } else {
                    this.blobUrl = null;
                    this.imageData = response;
                }
                // this.viewDocumentDetails(response.responseData);
                this.imageError = false;
                // }
            },
            error: (error: any) => {
                this.imageData = '';
                this.imageError = true;
                console.error('Error loading image path:', error);
            },
        });
    }
    viewDocumentDetails(doc: any): void {
        this.imageData = doc?.imageName?.includes('http')
            ? doc?.imageName
            : doc?.imageUrl?.includes('http')
                ? doc?.imageUrl
                : doc;
    }

    showNoImageFound(): void {
        this.imageData = 'assets/images/no-image-found.png';
        this.imageError = true;
    }

    private createQrCode(): void {
        const dob = this.formatDate(this.memDob);
        const joinDate = this.formatDate(this.regDate);
        this.dataToString = [
            `Rel:${this.relationName}`,
            `MemID:${this.contCode}`,
            `SHG:${this.shgName}`,
            `SHGID:${this.shgCode}`,
            `DOB:${dob}`,
            `FormDt:${this.shgFormationDate}`,
            `JoinDt:${joinDate}`,
        ].join('|');

        console.log(this.dataToString);
    }
    onImgError(image: any) {
        image.target.src = 'https://cdn.lokos.in/assets/img/avatar.png';
    }
    loadMemberBasic() {
        this.shgProfileService
            .GetMemberBasicDetails(this.shgId, this.memberUUId)
            .subscribe((response: any) => {
                if (response) {
                    console.log(response);
                    this.memDob = response?.dob;
                    this.relationName = response?.relation_name;
                    this.joiningDate = response?.joining_date;
                    this.loadImage(response);
                    this.createQrCode();
                }
            });
    }
    formatDate(value: string | null | undefined): string {
        if (!value) return '';
        try {
            const date = new Date(value);
            if (isNaN(date.getTime())) return value;
            const dd = String(date.getUTCDate()).padStart(2, '0');
            const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
            const yyyy = date.getUTCFullYear();
            return `${dd}/${mm}/${yyyy}`;
        } catch {
            return value;
        }
    }

    ngOnDestroy(): void {
        // Clean up blob URLs to prevent memory leaks
        if (this.blobUrl) {
            URL.revokeObjectURL(this.blobUrl);
        }
    }
}
